import { createEnvelopeSource } from './create-envelope-source';
import { withCampaignWindows } from './create-campaign-source';
import type { CampaignSourceConfig } from './create-campaign-source';
import { ROAD_TO_REWARDS_CAMPAIGN_ID } from './road-to-rewards-campaign';

type CouponsIssuedMetric = 'couponsIssued';

const config: CampaignSourceConfig<CouponsIssuedMetric> = {
    label: 'Issued coupons',
    endpoint: 'analytics/coupons/issued',
    metrics: [{ id: 'couponsIssued', label: 'Coupons issued', type: 'scalar' }],
    forms: ['trio'],
    regionGrain: 'province',
    staticParams: { campaign: ROAD_TO_REWARDS_CAMPAIGN_ID },
};

export const campaignCouponsIssuedSource = withCampaignWindows(
    createEnvelopeSource(config),
    config
);
